import registerServiceWorker from "./config/registerServiceWorker";
import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import { MuiThemeProvider, createMuiTheme } from "material-ui/styles";

import store, { history } from "./modules/store";
import App from "./containers/App/App";
import "./index.css";

const target = document.querySelector("#root");

const theme = createMuiTheme({
  palette: {
    primary: {
      "50": "#e3f2fd",
      "100": "#bbdefb",
      "200": "#90caf9",
      "300": "#64b5f6",
      "400": "#42a5f5",
      "500": "#2000b8",
      "600": "#1e88e5",
      "700": "#1976d2",
      "800": "#1565c0",
      "900": "#0d47a1",
      A100: "#82b1ff",
      A200: "#448aff",
      A400: "#2979ff",
      A700: "#2000b8",
      contrastDefaultColor: "light"
    }
  },
  typography: {
    fontFamily: '"Exo 2", "Helvetica", "Arial", sans-serif',
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    display4: {
      fontSize: "7rem",
      fontWeight: 300,
      fontFamily: '"Exo 2", "Helvetica", "Arial", sans-serif',
      letterSpacing: "-.04em",
      lineHeight: "1.14286em",
      marginLeft: "-.06em",
      color: "rgba(0, 0, 0, 0.54)"
    }
  }
});

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <MuiThemeProvider theme={theme}>
        <App />
      </MuiThemeProvider>
    </ConnectedRouter>
  </Provider>,
  target
);



// WEBPACK FOOTER //
// ./src/index.js